import { render } from "./DeliveryHours.vue?vue&type=template&id=c1639452&scoped=true"
import script from "./DeliveryHours.vue?vue&type=script&lang=js"
export * from "./DeliveryHours.vue?vue&type=script&lang=js"

import "./DeliveryHours.vue?vue&type=style&index=0&id=c1639452&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1639452"]])

export default __exports__